const translation = {
  toVerifiedTip: {
    coupon: 'विशेष 100% कूपन',
    front: 'आप अब शिक्षा सत्यापित स्थिति के लिए योग्य हैं। कृपया नीचे अपनी शिक्षा की जानकारी प्रदान करें ताकि प्रक्रिया को पूरा किया जा सके और एक प्राप्त हो सके',
    end: 'Dify प्रोफेशनल योजना के लिए।',
  },
  form: {
    schoolName: {
      placeholder: 'अपनी स्कूल का आधिकारिक, बिना संक्षिप्त नाम दर्ज करें',
      title: 'आपके स्कूल का नाम',
    },
    schoolRole: {
      option: {
        administrator: 'स्कूल प्रशासक',
        student: 'छात्र',
        teacher: 'शिक्षक',
      },
      title: 'आपकी स्कूल की भूमिका',
    },
    terms: {
      desc: {
        and: 'और',
        termsOfService: 'सेवाओं की शर्तें',
        privacyPolicy: 'गोपनीयता नीति',
        end: '. प्रस्तुत करके:',
        front: 'आपकी जानकारी और शिक्षा सत्यापित स्थिति का उपयोग हमारी शर्तों के अधीन है।',
      },
      option: {
        age: 'मैं पुष्टि करता हूँ कि मैं कम से कम 18 साल का हूँ',
        inSchool: 'मैं पुष्टि करता हूँ कि मैं दी गई संस्थान में नामांकित या नियुक्त हूं। Dify नामांकन/नियुक्ति का प्रमाण मांग सकता है। यदि मैं अपनी पात्रता का गलत वर्णन करता हूं, तो मैं सहमत हूं कि मैं अपने शिक्षा स्थिति के आधार पर किसी भी शुल्क का भुगतान करूं जो प्रारंभ में माफ किया गया था।',
      },
      title: 'नियम और शर्तें',
    },
  },
  submitError: 'फॉर्म जमा करने में विफलता हुई। कृपया बाद में पुनः प्रयास करें।',
  currentSigned: 'वर्तमान में साइन इन किया गया है के रूप में',
  learn: 'शिक्षा को प्रमाणित कराने का तरीका सीखें',
  toVerified: 'शिक्षा की पुष्टि कराएँ',
  emailLabel: 'आपका वर्तमान ईमेल',
  submit: 'सबमिट करें',
  rejectTitle: 'आपकी डिफाई शैक्षणिक सत्यापन को अस्वीकृत कर दिया गया है',
  successTitle: 'आपकी डिफाई शिक्षा को सत्यापित किया गया है',
  successContent: 'हमने आपकी खाते के लिए Dify प्रोफेशनल योजना के लिए 100% छूट कूपन जारी किया है। यह कूपन एक वर्ष के लिए मान्य है, कृपया इसे मान्यता की अवधि के भीतर उपयोग करें।',
  rejectContent: 'दुर्भाग्यवश, आप शिक्षा सत्यापित स्थिति के लिए योग्य नहीं हैं और इसलिए यदि आप इस ईमेल पते का उपयोग करते हैं, तो आप डिफाई प्रोफेशनल योजना के लिए विशेष 100% कूपन प्राप्त नहीं कर सकते।',
}

export default translation
